/**
 * Container — max-width content wrapper with 8pt padding.
 * UI stability primitive: 1280px max-width, var(--space-5) padding-inline.
 */
import React from 'react';

export default function Container({ children, className = '', style = {}, ...rest }) {
  return (
    <div
      className={className}
      style={{
        maxWidth: 1280,
        width: '100%',
        marginInline: 'auto',
        paddingInline: 'var(--space-5)',
        boxSizing: 'border-box',
        ...style,
      }}
      {...rest}
    >
      {children}
    </div>
  );
}
